// 经纪人筛选规则
let salesmanRule = [
  {
    title: '性别',
    field: 'sex',
    check: [],
    multiple: true,
    options: [
      {
        label: '男',
        value: '1'
      }, {
        label: '女',
        value: '2'
      }, {
        label: '未知',
        value: '9'
      }
    ]
  },
  // {
  //   title: '代征代缴类型',
  //   field: 'levyType',
  //   check: [],
  //   multiple: true,
  //   options: [
  //     {
  //       label: '代征',
  //       value: '1'
  //     }, {
  //       label: '代缴',
  //       value: '2'
  //     }, {
  //       label: '代征代缴',
  //       value: '3'
  //     }
  //   ]
  // },
  {
    title: '年龄段',
    field: 'ageRange',
    check: [],
    multiple: true,
    options: [
      {
        label: '18~25岁',
        value: '1'
      }, {
        label: '26~30岁',
        value: '2'
      }, {
        label: '31~45岁',
        value: '3'
      }, {
        label: '40~60岁',
        value: '4'
      }
    ]
  }, {
    title: '擅长产品',
    field: 'adeptProd',
    check: '',
    options: [
      {
        label: 'RX',
        value: 'RX'
      }, {
        label: 'OTC',
        value: 'OTC'
      }, {
        label: '器械',
        value: '器械'
      }, {
        label: '中药饮片',
        value: '中药饮片'
      }
    ]
  }, {
    title: '人员类型',
    field: 'staffType',
    check: '',
    options: [
      {
        label: '已备案',
        value: '1'
      }, {
        label: '未备案',
        value: '2'
      }
    ]
  }, {
    title: '会员渠道',
    field: 'damId',
    check: '',
    type: 'autocomplete'
  }
]
// 终端筛选规则
let terminalRule = [
  {
    title: '终端类型',
    field: 'terminalType',
    check: '',
    options: [
      {
        label: '第一终端',
        value: '第一终端',
        child: [
          {
            label: '三级',
            value: '三级'
          }, {
            label: '二级',
            value: '二级'
          }, {
            label: '一级',
            value: '一级'
          }, {
            label: '未知',
            value: '未知'
          }
        ]
      }, {
        label: '第二终端',
        value: '第二终端',
        child: [
          {
            label: '连锁总部',
            value: '连锁总部'
          }, {
            label: '连锁门店',
            value: '连锁门店'
          }, {
            label: '单体药店',
            value: '单体药店'
          }
        ]
      }, {
        label: '第三终端',
        value: '第三终端',
        child: [
          {
            label: '诊所',
            value: '诊所'
          }, {
            label: '门诊',
            value: '门诊'
          }, {
            label: '卫生院/室',
            value: '卫生院/室'
          }, {
            label: '社区服务中心(含服务站)',
            value: '社区服务中心(含服务站)'
          }, {
            label: '其他',
            value: '其他'
          }
        ]
      }
    ]
  }, {
    title: '终端子类',
    field: 'terminalSubType',
    check: '',
    options: []
  }, {
    title: '建档时间',
    field: 'filingTimeRange',
    check: '',
    options: [
      {
        label: '6个月以内',
        value: '1'
      }, {
        label: '7~12个月',
        value: '2'
      }, {
        label: '1~2年',
        value: '3'
      }, {
        label: '2年以上',
        value: '4'
      }
    ]
  }
]
// 渠道筛选规则
const channelRule = [
  // {
  //   title: '人员类型',
  //   field: 'teamType',
  //   check: '',
  //   options: [
  //     {
  //       label: '自由团队',
  //       value: '自由团队'
  //     }, {
  //       label: '代理团队',
  //       value: '代理团队'
  //     }
  //   ]
  // },
  {
    title: '建档时间',
    field: 'filingTimeRange',
    check: '',
    options: [
      {
        label: '6个月以内',
        value: '1'
      }, {
        label: '7~12个月',
        value: '2'
      }, {
        label: '1~2年',
        value: '3'
      }, {
        label: '2年以上',
        value: '4'
      }
    ]
  }, {
    title: '是否SAAS会员',
    field: 'isMember',
    check: '',
    options: [
      {
        label: 'SAAS会员',
        value: '是'
      }, {
        label: '非SAAS会员',
        value: '否'
      }
    ]
  }
]

const provinceCenter = {
  新疆维吾尔自治区: [86.61, 40.79],
  西藏自治区: [89.13, 30.66],
  黑龙江省: [128.34, 47.05],
  吉林省: [126.32, 43.38],
  辽宁省: [123.42, 41.29],
  内蒙古自治区: [112.17, 42.81],
  北京市: [116.40, 40.40],
  宁夏回族自治区: [106.27, 36.76],
  山西省: [111.95, 37.65],
  河北省: [115.21, 38.44],
  天津市: [117.04, 39.52],
  青海省: [97.07, 35.62],
  甘肃省: [103.82, 36.05],
  山东省: [118.01, 36.37],
  陕西省: [108.94, 34.46],
  河南省: [113.46, 34.25],
  安徽省: [117.28, 31.86],
  江苏省: [120.26, 32.54],
  上海市: [121.46, 31.28],
  四川省: [103.36, 30.65],
  湖北省: [112.29, 30.98],
  浙江省: [120.15, 29.28],
  重庆市: [107.51, 29.63],
  湖南省: [112.08, 27.79],
  江西省: [115.89, 27.97],
  贵州省: [106.91, 26.67],
  福建省: [118.31, 26.07],
  云南省: [101.71, 24.84],
  台湾省: [121.01, 23.54],
  广西壮族自治区: [108.67, 23.68],
  广东省: [113.98, 22.82],
  海南省: [110.03, 19.33],
  澳门特别行政区: [113.54, 22.19],
  香港特别行政区: [114.17, 22.32]
}

/**
 * 1人员、2终端服务、3销售流向、4采购、5配送
**/
const nodeStyle = [
  { type: '1-1', tab: '同事', lineWords: 6, itemStyle: { color: '#C4D2F4', borderColor: '#4671DB'} },
  { type: '1-2', tab: '上级', lineWords: 6, itemStyle: { color: '#C6DFEF', borderColor: '#4B9CCE'} },
  { type: '1-3', tab: '下级', lineWords: 6, itemStyle: { color: '#CEC5EF', borderColor: '#644ACC'} },
  { type: '1-4', tab: '备案公司', lineWords: 12, itemStyle: { color: '#C6B7E0', borderColor: '#4C1B9D'} },
  { type: '1-5', tab: '备案人员', lineWords: 6, itemStyle: { color: '#C2AFCF', borderColor: '#400468'} },
  { type: '2-1', tab: '联系人', lineWords: 6, itemStyle: { color: '#B7DAC4', borderColor: '#10853D'} },
  { type: '2-2', tab: '等级医院', lineWords: 10, itemStyle: { color: '#C5EAE0', borderColor: '#3FBC98'} },
  { type: '2-3', tab: '药店', lineWords: 10, itemStyle: { color: '#CADCE3', borderColor: '#4F8EA4'} },
  { type: '2-4', tab: '基层医疗', lineWords: 10, itemStyle: { color: '#C4D0DD', borderColor: '#3B6391'} },
  { type: '2-5', tab: '渠道', lineWords: 12, itemStyle: { color: '#B4EAC9', borderColor: '#06BA4C'} },
  { type: '2-6', tab: '服务人员', lineWords: 6, itemStyle: { color: '#D8EFE1', borderColor: '#7ECD9D'} },
  { type: '2-7', tab: '客情', lineWords: 6, itemStyle: { color: '#CFEFF2', borderColor: '#0EA5B2'} },
  { type: '2-8', tab: '医生', lineWords: 6, itemStyle: { color: '#B4D5D8', borderColor: '#07747D'} },
  { type: '2-9', tab: '信息传递', lineWords: 16, itemStyle: { color: '#BBE8EC', borderColor: '#1FB4C0'} },
  { type: '2-10', tab: '渠道客情', lineWords: 6, itemStyle: { color: '#D8EFE1', borderColor: '#7ECD9D'} },
  { type: '2-11', tab: '医药客情', lineWords: 6, itemStyle: { color: '#D8EFE1', borderColor: '#7ECD9D'} },
  { type: '2-12', tab: '科室', lineWords: 6, itemStyle: { color: '#D8EFE1', borderColor: '#7ECD9D'} },
  { type: '4-1', tab: '采购', lineWords: 12, itemStyle: { color: '#FCD5E0', borderColor: '#F87499'} },
  { type: '4-2', tab: '配送', lineWords: 12, itemStyle: { color: '#D4D2FA', borderColor: '#7269F2'} },
  { type: '5-1', tab: '产品', lineWords: 16, itemStyle: { color: '#FECEC1', borderColor: '#FC5D32'} },
  { type: '5-2', tab: '销售', lineWords: 12, itemStyle: { color: '#FBEDBF', borderColor: '#F2C32C'} },
  { type: '5-3', tab: '上市许可人', lineWords: 12, itemStyle: { color: '#FFDFC8', borderColor: '#FF974B'} },
  { type: '5-4', tab: '销售人员', lineWords: 6, itemStyle: { color: '#FEEEE6', borderColor: '#C9612C'} },
]
/**
 * 1人员、2终端服务、3销售流向、4采购、5配送
**/
const miniNodeStyle = [
  { type: '1-1', tab: '同事', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '1-2', tab: '上级', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '1-3', tab: '下级', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '1-4', tab: '备案公司', lineWords: 12, itemStyle: { color: '#4C1B9D', borderColor: '#4C1B9D'} },
  { type: '1-5', tab: '备案人员', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '2-1', tab: '联系人', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '2-2', tab: '等级医院', lineWords: 12, itemStyle: { color: '#3FBC98', borderColor: '#3FBC98'} },
  { type: '2-3', tab: '药店', lineWords: 12, itemStyle: { color: '#3FBC98', borderColor: '#3FBC98'} },
  { type: '2-4', tab: '基层医疗', lineWords: 12, itemStyle: { color: '#3FBC98', borderColor: '#3FBC98'} },
  { type: '2-5', tab: '渠道', lineWords: 12, itemStyle: { color: '#4C1B9D', borderColor: '#4C1B9D'} },
  { type: '2-6', tab: '服务人员', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '2-7', tab: '客情', lineWords: 8, itemStyle: { color: '#1FB4C0', borderColor: '#1FB4C0'} },
  { type: '2-8', tab: '医生', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '2-9', tab: '信息传递', lineWords: 12, itemStyle: { color: '#1FB4C0', borderColor: '#1FB4C0'} },
  { type: '2-10', tab: '渠道客情', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '2-11', tab: '医药客情', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '2-12', tab: '科室', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
  { type: '4-1', tab: '采购', lineWords: 12, itemStyle: { color: '#1FB4C0', borderColor: '#1FB4C0'} },
  { type: '4-2', tab: '配送', lineWords: 12, itemStyle: { color: '#4C1B9D', borderColor: '#4C1B9D'} },
  { type: '5-1', tab: '产品', lineWords: 12, itemStyle: { color: '#1FB4C0', borderColor: '#1FB4C0'} },
  { type: '5-2', tab: '销售', lineWords: 12, itemStyle: { color: '#4C1B9D', borderColor: '#4C1B9D'} },
  { type: '5-3', tab: '上市许可人', lineWords: 12, itemStyle: { color: '#4C1B9D', borderColor: '#4C1B9D'} },
  { type: '5-4', tab: '销售人员', lineWords: 6, itemStyle: { color: '#FF878B', borderColor: '#FF878B'} },
]
const  chinaJson = [];
export {
  chinaJson,
  salesmanRule,
  terminalRule,
  channelRule,
  provinceCenter,
  nodeStyle,
  miniNodeStyle
}
